module.exports = __webpack_public_path__ + "img/fail.62e70f38b.svg";